import { useInteractionProposalPreview } from '@debbie/cortex/dist/agents/index.js';
import { h } from '@debbie/cortex/dist/index.js';
import React from 'react';
import { styled } from 'styled-components';
import THEME from '../../theme.js';
import Interaction from '../Interaction/Interaction.js';
import PlaceholderLoader from '../PlaceholderLoader.js';
const ErrorRow = styled.div `
  font-size: 0.8em;
  color: ${THEME.DANGEROUS};
  white-space: pre-wrap;
`;
const InteractionPreview = ({ proposalId, edits }) => {
    const loadable = useInteractionProposalPreview(proposalId, edits);
    if (h.isError(loadable)) {
        return React.createElement(ErrorRow, null, loadable.error.message);
    }
    // null .data after hasData() means still warming up, not absent.
    if (!h.hasData(loadable) || !loadable.data) {
        return React.createElement(PlaceholderLoader, null);
    }
    return (React.createElement(Interaction, { interaction: loadable.data, alwaysExtended: true, notActionable: true }));
};
export default InteractionPreview;
//# sourceMappingURL=InteractionPreview.js.map